module.exports = __webpack_public_path__ + "img/makerdai-disabled.ce082a6f.svg";